export enum UserLevel {
    SiteEmployee = "Site Employee",
    SiteAdmin = "Site Admin",
    OrgAdmin = "Org Admin",
    DealerAdmin = "Dealer Admin",
    GlobalAdmin = "Global Admin"
}
